// Generated by scripts/mdi/import-questionnaires.mjs from MDI "Emideltide (DSIP) 09.17.26" (31f4ad82-d471-4129-87a8-d6d907c46e67). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiEmideltideDSIPQuestions = [
  {
    field: 'mdiEmideltideDSIP_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field: 'mdiEmideltideDSIP_pregnancy',
    label: 'Are you currently pregnant?',
    type: 'select',
    extras: { sendToBeluga: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    }
  },
  {
    field: 'mdiEmideltideDSIP_wereSorryTreatmentNotMedically',
    label:
      "We're sorry, this treatment is not medically appropriate for you at this time.",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'e5030658-e32d-4659-9a27-480b5c6519a0',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiEmideltideDSIP_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: Please click the attached link to review the consent for your peptide therapy treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the Peptide therapy consent (https://drive.google.com/file/d/1m0-PeXsGkuEF3BWjabwHarCb4_Ou7T_M/view)',
    answer: {
      type: 'text',
      name: 'mdiEmideltideDSIP_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: 'd9a64feb-8586-40d8-b905-3b177b351926' }
  },
  {
    field: 'mdiEmideltideDSIP_reasonInterestedPeptide',
    label: 'What is the reason you are interested in this peptide?',
    type: 'select',
    educationalSlide: 'Select all that apply',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'chronic_insomnia_and_sleep_onset_difficu',
          value: 'Chronic insomnia and sleep-onset difficulties'
        },
        {
          key: 'poor_sleep_quality_with_frequent_nightti',
          value: 'Poor sleep quality with frequent nighttime awakenings'
        },
        {
          key: 'stress_related_sleep_disturbances',
          value: 'Stress-related sleep disturbances'
        },
        {
          key: 'recovery_support_for_athletes_and_physic',
          value:
            'Recovery support for athletes and physically active individuals'
        },
        { key: 'chronic_pain_conditions', value: 'Chronic pain conditions' },
        {
          key: 'withdrawal_management_in_substance_use_d',
          value: 'Withdrawal management in substance use disorders'
        },
        {
          key: 'mood_regulation_and_stress_resilience',
          value: 'Mood regulation and stress resilience'
        },
        { key: 'age_related_sleep_decline', value: 'Age-related sleep decline' }
      ]
    },
    extras: { mdiQuestionId: 'be4c3fb2-27d6-4319-99ef-76a86cf5936c' }
  },
  {
    field: 'mdiEmideltideDSIP_everUsedPeptideTherapiesPast',
    label: 'Have you ever used peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'cf638f24-0b61-4277-beb7-740b3007c9e3' }
  },
  {
    field: 'mdiEmideltideDSIP_peptidesUsedPreviously',
    label: 'What peptides have you used previously?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiEmideltideDSIP_peptidesUsedPreviously',
      rows: 4
    },
    extras: { mdiQuestionId: '48fe67f8-55de-41fe-859b-75dafadfd0dd' }
  },
  {
    field: 'mdiEmideltideDSIP_everReactionSideEffectsPeptide',
    label:
      'Have you ever had a reaction or side effects to peptide therapies in the past?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: 'd40cac39-b53b-4f24-9302-ff992105edcd' }
  },
  {
    field: 'mdiEmideltideDSIP_reactionSideEffect',
    label: 'What was your reaction or side effect?',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiEmideltideDSIP_reactionSideEffect',
      rows: 4
    },
    extras: { mdiQuestionId: '182baffc-d02f-422b-ab54-3af01baeee61' }
  },
  {
    field: 'mdiEmideltideDSIP_diagnosedRedFlagMedicalConditions',
    label:
      'Do you currently have or have you been diagnosed with any of the following red flag medical conditions listed below that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'cancer', value: 'Cancer' },
        {
          key: 'cardiovascular_disease_such_as_heart_att',
          value: 'Cardiovascular disease such as heart attack, stroke, etc'
        },
        { key: 'kidney_disease', value: 'Kidney disease' },
        { key: 'liver_disease', value: 'Liver disease' },
        {
          key: 'sleep_apnea_chronic_respiratory_disease',
          value: 'Sleep apnea/Chronic respiratory disease'
        },
        { key: 'psychiatric_illness', value: 'Psychiatric illness' },
        { key: 'suicidal_thoughts', value: 'Suicidal thoughts' },
        {
          key: 'neurosurgery_within_the_past_6_months',
          value: 'Neurosurgery within the past 6 months'
        },
        {
          key: 'pituitary_brain_or_other_intracranial_tu',
          value: 'Pituitary, brain or other intracranial tumors'
        },
        {
          key: 'uncontrolled_intracranial_hypertension',
          value: 'Uncontrolled intracranial hypertension'
        },
        {
          key: 'uncontrolled_seizure_disorder',
          value: 'Uncontrolled seizure disorder'
        },
        {
          key: 'uncontrolled_thyroid_disease',
          value: 'Uncontrolled thyroid disease'
        },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_these_apply_to_me', value: 'None of these apply to me' }
      ]
    },
    extras: { mdiQuestionId: 'f7dbffa6-b42d-4d89-8c4b-707c96876d6a' }
  },
  {
    field: 'mdiEmideltideDSIP_confirmNotHistoryCancerKidney',
    label:
      'Please confirm you do not have any history of cancer, kidney or liver disease:',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'i_agree_i_do_not_have_any_history_of_can',
          value:
            'I agree, I do NOT have any history of cancer, kidney or liver disease'
        },
        {
          key: 'i_have_been_diagnosed_with_cancer_or_hav',
          value:
            'I HAVE been diagnosed with cancer or have had problems with my kidneys or liver previously'
        }
      ]
    },
    extras: { mdiQuestionId: '65df597f-c1af-4e3c-88f4-6738bb6c1533' }
  },
  {
    field: 'mdiEmideltideDSIP_takeRedFlagMedicationsSubstances',
    label:
      'Do you take any of the following red flag medications or substances that may disqualify you from treatment?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'hypnotics_or_sedatives', value: 'Hypnotics or sedatives' },
        { key: 'sleeping_aids', value: 'Sleeping aids' },
        { key: 'heavy_alcohol_use', value: 'Heavy alcohol use' },
        {
          key: 'benzodiazepines_like_xanax_alprazolam_or',
          value:
            'Benzodiazepines like xanax (alprazolam) or ativan (lorazepam), etc'
        },
        { key: 'ketamine', value: 'Ketamine' },
        { key: 'memantine', value: 'Memantine' },
        { key: 'opioid_pain_medication', value: 'Opioid pain medication' },
        { key: 'antidepressants', value: 'Antidepressants' },
        { key: 'clonidine', value: 'Clonidine' },
        { key: 'guanfacine', value: 'Guanfacine' },
        {
          key: 'high_blood_pressure_medication',
          value: 'High blood pressure medication'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '265bfd21-5348-4878-b60a-5ea8a54b8792' }
  },
  {
    field: 'mdiEmideltideDSIP_manyAlcoholicDrinksConsumeOne',
    label: 'How many alcoholic drinks do you consume in one week?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'o_1_3', value: '1-3' },
        { key: 'o_3_6', value: '3-6' },
        { key: 'o_6_9', value: '6-9' },
        { key: 'o_10_or_more', value: '10 or more' }
      ]
    },
    extras: { mdiQuestionId: '34a0fc04-2e32-42e0-97fd-9f248b129d70' }
  },
  {
    field: 'mdiEmideltideDSIP_allergyBenzylPeroxide',
    label: 'Do you have an allergy to benzyl peroxide?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no', value: 'No' }
      ]
    },
    extras: { mdiQuestionId: '9dec5fff-35c3-4b69-a175-244cba43ada7' }
  },
  {
    field: 'mdiEmideltideDSIP_lastTimePersonMedicalEvaluation',
    label: 'When was the last time you had an in-person medical evaluation?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_2_years_ago', value: '1-2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: '0c1d3bb4-dd7c-4e8c-bd40-82a4defd64cd' }
  },
  {
    field: 'mdiEmideltideDSIP_confirmUnderstandContactDoctorQuestions',
    label:
      'Please confirm the following: I understand and will contact my doctor if I have any questions',
    type: 'info',
    subLabel:
      'I understand that this peptide therapy is for use as a subcutaneous injection. I understand I will have to draw up and administer this injection myself. I understand that administering incorrectly or the wrong amount of this peptide therapy may cause serious side effects. I agree that I will reach out to my doctor prior to administering if I have any questions so that I can do it correctly\n\nType your full legal name below:',
    answer: {
      type: 'text',
      name: 'mdiEmideltideDSIP_confirmUnderstandContactDoctorQuestions'
    },
    extras: { mdiQuestionId: '9d756658-f7a1-4ea7-a3c9-efa859aeec5e' }
  },
  {
    field: 'mdiEmideltideDSIP_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Feel free to introduce yourself, ask any questions, or list any concerns you may have.',
    answer: {
      type: 'text',
      name: 'mdiEmideltideDSIP_firstMessageDoctor',
      rows: 4
    },
    extras: { mdiQuestionId: '5fd59798-43db-4af5-870f-52d2e243e53d' }
  },
  {
    field: 'mdiEmideltideDSIP_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiEmideltideDSIPAnswerField = Partial<
  QuestionAnswerMap<typeof mdiEmideltideDSIPQuestions>
>;

export default mdiEmideltideDSIPQuestions;
